import { OrderData, OrderItemData, OrderItemGroupData } from '../../../app/data/model';
import { Alert } from '../../../app/shared/alert/Alert';
import { formatISODateStringToDottedDate } from '../../../app/shared/commonDate';
import List from '../../../app/shared/components/List/List';
import { Panel } from '../../../app/shared/components/Panel/Panel';
import { OrderItemTranslation, OrderTranslation } from '../../localization/SiteTranslation';
import { OrderHeader } from '../OrderHeader/OrderHeader';
import { OrderItem } from '../OrderItem/OrderItem';
import { formatExpectedShippingMessage } from '../OrderState';
import css from './Order.css';
import { OrderItemGroup } from './OrderItemGroup/OrderItemGroup';

interface OrderProps {
  translation: OrderTranslation;
  order: OrderData;
}

export const Order = ({ order, translation }: OrderProps) => {
  const shippingMessage = !!order.shippingDate
    ? order.shippingDate &&
      translation.shippingDateFormat.interpolate([['date', formatISODateStringToDottedDate(order.shippingDate)]])
    : order.expectedShipping && formatExpectedShippingMessage(order.expectedShipping, translation.shippingMessage);
  const items = [...order.items, ...order.groups];

  return (
    <>
      {order.erpChangesNotSynchronized && (
        <Alert className={css.alertDanger}>{translation.changesInOrderAlertText}</Alert>
      )}

      <Panel
        headerComponent={
          <OrderHeader
            orderNo={order.number}
            date={order.createdDate}
            price={order.total}
            name={order.customName}
            reference={order.customReference}
            buyer={order.customerName}
            status={order.status}
            expectedShippingMessage={shippingMessage}
            translation={translation.orderHeader}
          />
        }
        bodyClassName={css.Order}
      >
        <List
          className={css.orderList}
          itemClassName={css.orderItem}
          items={items}
          itemRenderer={(orderItem, key) => <LineItem item={orderItem} key={key} translation={translation.orderItem} />}
        />
      </Panel>
    </>
  );
};

interface LineItemProps {
  item: OrderItemData | OrderItemGroupData;
  translation: OrderItemTranslation;
}

const LineItem = ({ item, translation }: LineItemProps) => {
  if (Object.hasOwnProperty.call(item, 'configurationCode')) {
    return <OrderItem item={item as OrderItemData} translation={translation} />;
  }

  if (Object.hasOwnProperty.call(item, 'modularCode')) {
    return <OrderItemGroup item={item as OrderItemGroupData} translation={translation} />;
  }

  return null;
};
